export default "__VITE_ASSET__tC2QPT7j__"